import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Chip from 'Chip';
import { formatUrl } from '@ifeng-fe/public_method';
import Search from '@ifeng-fe/ui_pc_search';
import styles from './index.css';
import { rel as relText } from '../../../utils/rel';
import { classNames } from '../../../utils/classnames';
import HtmlRegion from '../../../components/htmlRegion';

class Logo extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { channel, search, slogan, banner1 } = this.props.content;

        return (
            <div className={classNames(styles.box, 'clearfix')}>
                <a className={styles.logo} href={formatUrl(channel[0].domain)} target="_blank" rel={relText}>
                    <img src={formatUrl(channel[0].logo)} alt={channel[0].title} />
                </a>
                <Chip id="30009" type="static" title="slogan" groupName="logo" content={slogan}>
                    <HtmlRegion className={styles.slogan} />
                </Chip>
                <Chip id="30010" type="static" title="banner" groupName="logo" content={banner1}>
                    <HtmlRegion className={styles.banner} />
                </Chip>
                <div className={styles.search}>
                    <Search content={search} />
                </div>
            </div>
        );
    }
}

export default Logo;
